<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 16 20">
    <g clip-path="url(#clip0_6892_8928)">
      <path
        d="M10.9233 1.95876C10.6233 0.837629 9.55965 0 8.27783 0C6.99601 0 5.94601 0.824742 5.64601 1.95876H0.777832V3.24742H15.7778V1.95876C15.7778 1.95876 10.9097 1.95876 10.9233 1.95876ZM8.27783 1.28866C8.79601 1.28866 9.23238 1.57216 9.47783 1.95876H7.11874C7.35056 1.57216 7.77329 1.28866 8.29147 1.28866H8.27783ZM13.7324 4.51031H15.096V18.067C15.096 19.1366 14.1824 20 13.0506 20H3.5051C2.37329 20 1.45965 19.1366 1.45965 18.067V4.51031H2.82329V18.067C2.82329 18.4149 3.12329 18.7113 3.5051 18.7113H13.0506C13.4324 18.7113 13.7324 18.4149 13.7324 18.067V4.51031ZM6.9142 5.79897V16.1082H5.55056V5.79897H6.9142ZM11.0051 5.79897V16.1082H9.64147V5.79897H11.0051Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8928">
        <rect width="15" height="20" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
